<template>
  <div class="header-container">
    <div class="school-logo">
      <div class="logo1 right-line"></div>
      <div class="logo2"></div>
      <!-- <div class="logo"></div> -->
    </div>
    <div class="school-name">
      <h1>高等教育自学考试助学培训报名系统</h1>
    </div>
    <div v-if="$route.path !== '/' && !$route.meta.isApply" class="user-handle">
      当前用户: {{ userName }}
      <el-button class="exit" @click="quit">退出</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHead",
  data() {
    return {
      showUserName: false,
    };
  },
  computed: {
    userName() {
      return this.$store.state.userName;
    },
  },
  created() {},
  mounted() {},
  methods: {
    quit() {
      // 退出到登录页
      this.$store.commit("userExit");
    },
  },
};
</script>

<style scoped lang="less">
.header-container {
  display: flex;
  padding: 0 20px;
  margin-bottom: 6px;
  box-sizing: border-box;
  background-color: #0356a1;
  .school-logo {
    margin-left: 40px;
    display: flex;
    align-items: center;
    // flex-direction: column;
    justify-content: center;
     .logo1{
      width: 250px;
      height: 82px;
      background: url('../assets/login/head_logo.png') 50% no-repeat;
      background-size: cover;
      -webkit-transform: scale(0.8);
      transform: scale(0.8);
    }
    .right-line {
      position: relative;
    }
    .right-line:after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: inline-block;
    height: 80%;
    left: 280px;
    border-right: 2px solid #fff;
}
 .logo2{
    width: 145px;
    height: 59px;
    background: url('../assets/login/login_log.png') 50% no-repeat;
    background-size: cover;
    -webkit-transform: scale(.85);
    transform: scale(.85);
    margin-left: 15px;
}

  }
  .school-name {
    margin-left: 1vw;
    line-height: 100px;
    color: white;
    letter-spacing: 3px;
  }
  .user-handle {
    margin-left: auto;
    display: flex;
    align-items: center;
    color: white;
    .exit {
      margin-left: 30px;
    }
  }
}
@media screen and (max-width: 1366px) {
  .school-logo {
    // margin-left: 120px !important;
  }
  .school-name {
    margin-left: 4vw !important;
  }
  .user-handle {
    .exit {
      margin-left: 20px !important;
    }
  }
}
</style>
